import(/* webpackMode: "eager" */ "/vercel/path0/app/achievements/page.tsx");
